import _ from "lodash";
import * as React from "react";
import { getUnitInputOptions, PropertyHelper, UnitInputPropertyName } from "../../../../shared/utility/property-helper";
import KuikaInput from "../../../ui-kit/kuika-input/kuika-input";
import KuikaSelectbox, { KuikaSelectboxOption } from "../../../ui-kit/kuika-selectbox/kuika-selectbox";

export interface IPropertyFormInputWithSelectPropertyState {
  value: string;
  widthOrHeightValue: string;
}

export interface IPropertyFormInputWithSelectPropertyProps {
  value: string;
  onChange: (value: string) => void;
  onWidthOrHeightChange: (value: string, type: string) => void;
  isWidthOrHeightProp?: UnitInputPropertyName;
  widthOrHeightValue?: string;
  changeType: "onBlur" | "onKeyPress";
  updateDebounce: number;
  disabled?: boolean;
}

export class PropertyFormInputWithSelectProperty extends React.PureComponent<
  IPropertyFormInputWithSelectPropertyProps,
  IPropertyFormInputWithSelectPropertyState
> {
  constructor(props) {
    super(props);
    // An empty value carries no unit, so fall back to px rather than showing a blank select.
    this.state = { value: this.props.value, widthOrHeightValue: this.props.widthOrHeightValue || "px" };
  }

  public static defaultProps = {
    changeType: "onKeyPress"
  };

  componentDidUpdate = (prevProps: IPropertyFormInputWithSelectPropertyProps) => {
    if (prevProps === this.props) return;
    this.setState({
      value: this.props.isWidthOrHeightProp
        ? PropertyHelper.getTextValueForDisplayWidthorHeight(this.props.value, this.state.widthOrHeightValue)
        : PropertyHelper.getTextValueForMetaData(this.props.value)
    });
  };

  waitAndChange = _.debounce((value: string) => this.props.onChange(value), this.props.updateDebounce);

  waitAndChangeWidthOrHeight = _.debounce(
    (value: string, type: string) => this.props.onWidthOrHeightChange(value, type),
    this.props.updateDebounce
  );

  clearInput = () => {
    this.props.onChange("");
  };

  handleChangeValue = (event: any) => {
    if (this.props.changeType === "onKeyPress") {
      const value = PropertyHelper.getTextValueForMetaData(event.target.value);
      this.waitAndChange(value);
    }
  };

  handleBlur = (event: any) => {
    if (this.props.changeType === "onBlur") {
      const value = PropertyHelper.getTextValueForMetaData(event.target.value);
      this.waitAndChange(value);
    }
  };

  handleWidthOrHeightChange = (event: any) => {
    const value = PropertyHelper.getTextValueForDisplayWidthorHeight(event.target.value, this.state.widthOrHeightValue);
    this.setState({ value }, () => {
      this.waitAndChangeWidthOrHeight(value, this.state.widthOrHeightValue);
    });
  };

  handleChangeWidthOrHeight = (unit: string): void => {
    const value = PropertyHelper.getTextValueForDisplayWidthorHeight(this.state.value, this.state.widthOrHeightValue);
    this.setState({ value, widthOrHeightValue: unit }, () => {
      this.waitAndChangeWidthOrHeight(value, this.state.widthOrHeightValue);
    });
  };

  render() {
    // px / % everywhere, plus the viewport unit of the property's own axis where one applies —
    // a Splitter pane gets neither, since its axis comes from the parent's orientation.
    const unitOptions: KuikaSelectboxOption[] = getUnitInputOptions(this.props.isWidthOrHeightProp).map(
      (unit: string): KuikaSelectboxOption => ({ key: unit, value: unit, label: unit })
    );
    return (
      <div className="kuika_property-grid-column kuika-right-panel__col">
        {/* Same unit-input pattern as Styling > Layout > Width/Height: a number field that
            fills the row plus a unit select just wide enough for "px" / "%" / "vw" / "vh". */}
        <div className="kuika-styling-panel__double-input-wrapper kuika-styling-panel__input-wrapper kuika-styling-panel__input-wrapper--full">
          <KuikaInput
            type="number"
            size="sm"
            // The width or height is stored as typed, unit handling and all; the kit would round
            // it to a whole number and hand a 0 back as a number the handler reads as empty.
            keepTypedValue
            value={PropertyHelper.getTextValueForDisplayWidthorHeight(this.state.value, this.state.widthOrHeightValue)}
            allowClear
            onChange={this.handleWidthOrHeightChange}
            onBlur={this.handleWidthOrHeightChange}
            disabled={this.props.disabled}
          />
          <KuikaSelectbox
            size="sm"
            suffixIcon={<></>}
            value={this.state.widthOrHeightValue}
            onChange={this.handleChangeWidthOrHeight}
            disabled={this.props.disabled}
            options={unitOptions}
          />
        </div>
      </div>
    );
  }
}
